import StyledWrapper from './style';

import { Button, DialogActions, DialogContentText } from '@mui/material';
import { useMediaQuery, useTheme } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

interface WarningModalProps {
	title?: string;
	content?: string;
	listItems?: string[];
	confirmationMessage?: string;
	open: boolean;
	handleClose: () => void;
	handleConfirm: () => void;
	confirmButtonText?: string;
	closeButtonText?: string;
}

const WarningModal = ({
	title,
	content,
	confirmationMessage,
	open,
	handleClose,
	handleConfirm,
	confirmButtonText = 'YES',
	closeButtonText = 'NO',
	listItems = []
}: WarningModalProps) => {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<StyledWrapper.CustomDialog
			disableEscapeKeyDown
			fullScreen={fullScreen}
			open={open}
			onClose={handleClose}
			aria-labelledby="responsive-dialog-title"
		>
			<StyledWrapper.CustomDialogTitle id="responsive-dialog-title">
				<WarningIcon color={'warning'} />
				{title}
			</StyledWrapper.CustomDialogTitle>
			<StyledWrapper.CustomDialogContent>
				<DialogContentText sx={{ fontWeight: '500' }}>
					<span style={{ display: 'flex', textAlign: 'left', marginBottom: '1rem' }}>
						{content}
					</span>

					<ul style={{ textAlign: 'left' }}>
						{listItems.map((item, index) => (
							<li key={index}>{item}</li>
						))}
					</ul>
					{confirmationMessage}
				</DialogContentText>
			</StyledWrapper.CustomDialogContent>
			<DialogActions style={{ justifyContent: 'center' }}>
				<Button size="large" variant="outlined" color="warning" onClick={handleConfirm} autoFocus>
					{confirmButtonText}
				</Button>
				<Button size="large" variant="contained" autoFocus onClick={handleClose}>
					{closeButtonText}
				</Button>
			</DialogActions>
		</StyledWrapper.CustomDialog>
	);
};

export default WarningModal;
